import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  spaceId: number;
  version: number;
};

const [useDeleteKitVersion, deleteKitVersion] = createAsyncAction(
  "kitVersions/delete",
  async ({ kitId, version }: Args) => {
    const res = await API.call<{ kitVersion: string }>({
      endpoint: `kits/${kitId}`,
      method: "PUT",
      data: {
        version: version,
        status: "deleted",
      },
    });
    return { ...res, result: res.result.kitVersion };
  }
);
export default useDeleteKitVersion;
export { deleteKitVersion };
